import moment from 'moment'

import 'moment/locale/zh-tw'

export default (ctx, inject) => {
  ctx.$moment = moment
  inject('moment', moment)
}
